module.exports = __webpack_public_path__ + "img/icon-sb-price-drop-tag-illustration-200x160.5b7b955.svg";